/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {A11yModule} from '@angular/cdk/a11y';
import {OverlayModule} from '@angular/cdk/overlay';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MdButtonModule} from '@angular/material/button';
import {MdDialogModule} from '@angular/material/dialog';
import {MdIconModule} from '@angular/material/icon';
import {MdCalendar} from './calendar';
import {MdCalendarBody} from './calendar-body';
import {
  MD_DATEPICKER_SCROLL_STRATEGY_PROVIDER,
  MdDatepicker,
  MdDatepickerContent,
} from './datepicker';
import {MdDatepickerInput} from './datepicker-input';
import {MdDatepickerIntl} from './datepicker-intl';
import {MdDatepickerToggle} from './datepicker-toggle';
import {MdMonthView} from './month-view';
import {MdYearView} from './year-view';
export class MdDatepickerModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdButtonModule,
    MdDialogModule,
    MdIconModule,
    OverlayModule,
    A11yModule,
  ],
  exports: [
    MdCalendar,
    MdCalendarBody,
    MdDatepicker,
    MdDatepickerContent,
    MdDatepickerInput,
    MdDatepickerToggle,
    MdMonthView,
    MdYearView,
  ],
  declarations: [
    MdCalendar,
    MdCalendarBody,
    MdDatepicker,
    MdDatepickerContent,
    MdDatepickerInput,
    MdDatepickerToggle,
    MdMonthView,
    MdYearView,
  ],
  providers: [
    MdDatepickerIntl,
    MD_DATEPICKER_SCROLL_STRATEGY_PROVIDER,
  ],
  entryComponents: [
    MdDatepickerContent,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDatepickerModule_tsickle_Closure_declarations() {
/** @type {?} */
MdDatepickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDatepickerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
